/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "new-patient-form",
  formField: {
    name: {
      name: "name",
      label: "Nombre(s)",
      type: "text",
      errorMsg: "El nombre es obligatorio.",
    },
    last_name: {
      name: "last_name",
      label: "Apellido Paterno",
      type: "text",
      errorMsg: "El apellido es obligatorio.",
    },
    mother_last_name: {
      name: "mother_last_name",
      label: "Apellido Materno",
      type: "text",
      errorMsg: "El apellido es obligatorio.",
    },
    email: {
      name: "email",
      label: "Correo Electrónico",
      type: "text",
      errorMsg: "El correo elecrónico es obligatorio.",
    },
    phone: {
      name: "phone",
      label: "Teléfono",
      type: "text",
      errorMsg: "El teléfono es obligatorio.",
    },
    date_of_birth: {
      name: "date_of_birth",
      label: "Fecha de Nacimiento",
      type: "date",
      options: {
        enableTime: false,
        disableMobile: true,
        dateFormat: 'Y-m-d'
      },
      errorMsg: "La fecha de nacimiento es obligatoria.",
    },
    comments: {
      name: "comments",
      label: "Notas",
      type: "text",
      multiline: true,
      rows: 2
    },
    doctor_id: {
      name: "doctor_id",
      label: "Doctor",
      type: "select",
      errorMsg: "El doctor es obligatorio.",
      invalidMsg: "El doctor es obligatorio."
    },
  },
};

export default form;
